import loadModels from './loadModels';
import loadCaptureModels from './loadCaptureModels';
import loadModelsExpression from './loadModelsExpression';
import loadDetection from './loadDetection';
import loadDetections from './loadDetections';
import getFaceDetectionFromBase64ImageCapture from './getFaceDetectionFromBase64ImageCapture';
import getFaceDetectionFromBase64Image from './getFaceDetectionFromBase64Image';
import saveFaceDetection from './saveFaceDetection';
import deleteFaceDetectionsByEvent from './deleteFaceDetectionsByEvent';
import getFaceDetectionByGuestAndEventId from './getFaceDetectionByGuestAndEventId';
import getFaceDetections from './getFaceDetections';
import validateFaceDetectionFromFile from './validateFaceDetectionFromFile';
import addGuestToFaceDetection from './addGuestToFaceDetection';
import updatePhotoAttributeValue from './updatePhotoAttributeValue';

export default {
  loadModels,
  loadCaptureModels,
  loadModelsExpression,
  loadDetection,
  loadDetections,
  getFaceDetectionFromBase64ImageCapture,
  getFaceDetectionFromBase64Image,
  saveFaceDetection,
  deleteFaceDetectionsByEvent,
  getFaceDetectionByGuestAndEventId,
  getFaceDetections,
  validateFaceDetectionFromFile,
  addGuestToFaceDetection,
  updatePhotoAttributeValue,
}
